import { IConfiguration } from 'next-common';
import { OrderCategory } from '../orderQuery.utils';
import { CategoryFilter } from './CategoryFilter';
import { Search } from '@repo/ui/components';

export interface IFilterBarProps {
  configuration?: IConfiguration;
  onChange(field: string, value: any): void;
  onCategoryChange(value: OrderCategory): void;
}

export const FilterBar = (props: IFilterBarProps) => {
  const handleCategoryChange = (value: OrderCategory) => {
    props.onCategoryChange(value);
  };

  const handleSearchChange = (searchString: string) => {
    props.onChange('searchQuery', searchString);
  };

  return (
    <div className="flex flex-col h-full gap-4">
      <div className="flex flex-col gap-1">
        <p className="font-semibold leading-[175%]">Søk etter serienummer</p>
        <Search onSearch={handleSearchChange} />
      </div>
      <CategoryFilter onChange={handleCategoryChange} configuration={props.configuration} />
    </div>
  );
};
